import { IStepControl, Step } from '../../../domains/wizard';
import { observer } from 'mobx-react';
import { HeaderReview } from './header-review';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../store';

interface IProps {
  stepControl: IStepControl;
}

export const DelegatesReview = observer((props: IProps) => {
  const { t } = useTranslation('', { keyPrefix: 'REVIEW_AND_SIGN_UP' });
  const { delegationInformationStore } = useStore();
  return (
    <div className="avoid-break">
      <div className="container-grey m-bottom-30">
        <HeaderReview stepControl={props.stepControl} step={Step.Delegate} />

        {delegationInformationStore.delegates.map((x, index) => (
          <div key={`${x.email.value} ${x.fullName.value}`} className="avoid-break">
            {index > 0 ? <hr /> : null}
            <h4>
              <span>{`${t('DELEGATE')} ${index + 1}`}</span>
            </h4>
            <div className="container-readonly">
              <label>{t('NAME')}</label>
              <span>{x.fullName.value}</span>
            </div>
            <div className="container-readonly">
              <label>{t('EMAIL')}</label>
              <span>{x.email.value}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});
